export default __webpack_public_path__ + "static/media/pl.4a805d66.svg";